import { USER_TYPE } from '../constants/App';

const tokenName = 'x-seller-token';
const headers = () => {
  const xToken = localStorage.getItem(tokenName);
  return {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'token': xToken
  }
};

const formHeaders = () => {
  const xToken = localStorage.getItem(tokenName);
  return {
    'Accept': 'application/json',
    //'Content-Type': 'multipart/form-data; boundary=XXX',
    'token': xToken

  }
};

const corsHeaders = () => {
  return {
    'Accept': 'application/xml',
    /*'Access-Control-Allow-Origin': '*',
    'Access-Control-Request-Method': 'POST',
    'Access-Control-Allow-Headers': 'access-control-allow-headers,access-control-allow-methods,access-control-allow-origin',*/
    //'Content-Type': 'multipart/form-data',


  }
};

const getToken = () => {
  return localStorage.getItem(tokenName);
}
const isValidToken = () => {
  const xToken = getToken();
  if (!xToken) {
    const originalUrl = document.location.path;
    //window.location.href = `/signin/?originalUrl=${originalUrl}`;
  }
  return !!xToken;
}

const defaultResponse = async (res, isLoginRequired) => {
  const status = res.status;

  if (status === 413) {
    return { resStatus: 413, message: 'Unable to submit request due to large image size, please select alternate images or remove one or more images.' }
  }

  else if (status === 403 && isLoginRequired) {
    localStorage.removeItem(tokenName);
    const originalUrl = document.location.path;
    //window.location.href = `/signin?originalUrl=${originalUrl}`;
    return { resStatus: status, message: 'Your token has expired, please login again.' }
  }
  else if (status === 504) {
    return { resStatus: status, message: 'Request timed out.' }
  }
  res = await res.json();
  if (status >= 400) {
    const message = res.message;
    return { resStatus: status, message: message }
  }
  return { ...res, resStatus: status }
}

const get = (api, isLoginRequired = true) => {
  if (isLoginRequired && !isValidToken()) {
    return null;
  }
  return fetch(api, {
    headers: headers(),
    credentials: 'include',
    method: 'GET'
  })
    .then((res) => defaultResponse(res, isLoginRequired));
};

const post = (api, data, isLoginRequired = true) => {
  if (isLoginRequired && !isValidToken()) {
    return null;
  }
  return fetch(api, {
    headers: headers(),
    credentials: 'include',
    method: 'POST',
    body: JSON.stringify(data)
  })
    .then((res) => defaultResponse(res, isLoginRequired));
};

const postFormData = (api, data, isLoginRequired = true) => {
  if (isLoginRequired && !isValidToken()) {
    return null;
  }

  return fetch(api, {
    headers: formHeaders(),
    credentials: 'include',
    method: 'POST',
    body: data
  })
    .then((res) => {
      return defaultResponse(res, isLoginRequired);
    });


};

const postCrossOriginFormData = (api, data) => {

  return fetch(api, {
    headers: corsHeaders(),
    method: 'POST',
    body: data
  })
    .then((res) => {


      //return defaultResponse(res, isLoginRequired);
    });


};

const put = (api, data, isLoginRequired = true) => {
  if (isLoginRequired && !isValidToken()) {
    return null;
  }
  return fetch(api, {
    headers: headers(),
    credentials: 'include',
    method: 'PUT',
    body: JSON.stringify(data)
  })
    .then((res) => defaultResponse(res, isLoginRequired));
};

const destroy = (api, isLoginRequired = true) => {
  if (isLoginRequired && !isValidToken()) {
    return null;
  }
  return fetch(api, {
    headers: headers(),
    credentials: 'include',
    method: 'DELETE'
  })
    .then((res) => defaultResponse(res, isLoginRequired));
};

const toggle = (api, isLoginRequired = true) => {
  if (isLoginRequired && !isValidToken()) {
    return null;
  }
  return fetch(api, {
    headers: headers(),
    credentials: 'include',
    method: 'PUT'
  })
    .then((res) => defaultResponse(res, isLoginRequired));
};

const login = (loginCredentials) => {
  return fetch('/api/login', {
    headers: { ...headers()},
    credentials: 'include',
    method: 'POST',
    body: JSON.stringify(loginCredentials)
  })
    .then((res) => defaultResponse(res))
    .then((res) => {
      if (res.resStatus == 200) {
        const { token } = res.data;
        localStorage.setItem(tokenName, token);
      }
      return res;
    });
}

const logout = async () => {
  await get('/api/logout');
  localStorage.removeItem(tokenName);
  window.location.href = '/signin';
}
export {
  headers,
  get,
  post,
  postFormData,
  postCrossOriginFormData,
  put,
  destroy,
  toggle,
  login,
  logout,
  getToken
};